export const theme = {
  courierInfoColor: Styles.color.grey.one,
  contactPromptColor: Styles.color.grey.one,
  contactInfoColor: Styles.color.grey.one,
  iconXFill: Styles.color.grey.three,
  statusMessageColor: Styles.color.grey.one,
};
